import { all, fork } from "redux-saga/effects";
import { campaignSaga } from "./sagas/campaignSaga";
import { sessionSaga } from "./sagas/sessionSaga";
export default function* rootSaga() {
  yield all([fork(campaignSaga), fork(sessionSaga)]);
}
